export default {
    namespaced: true,

    state: {
        OrgId: null,
        BrowserFingerPrint: null,
        BrowserIdentifier: null
    },

    getters: {
        /**
         * Monta o contrato do subtmit
         */
        getSubmitModel(state) {
            return {
                GatewayFingerprint: state.BrowserFingerPrint,
                BrowserIdentifier: state.BrowserIdentifier
            };
        },
    },

    mutations: {
        /**
         * Mapeia o response da api para o módulo
         */
        setFromRequest(state, data) {
            state.OrgId = data.AntifraudOrgId;
            state.BrowserFingerPrint = data.BrowserFingerPrint;
            state.BrowserIdentifier = data.BrowserIdentifier;
        }
    },

    actions: {
        /**
         * Carrega o script de fingerprint do antifraud
         */
        loadAntifraudScript({ state }) {
            let fingerprintUrlQuery = `?org_id=${state.OrgId}&session_id=${state.BrowserFingerPrint}`;
            let antifraudScript = document.createElement('script');
            antifraudScript.setAttribute('src', `//h.online-metrix.net/fp/tags.js${fingerprintUrlQuery}`);
            document.head.appendChild(antifraudScript);

            appendCyberNoscriptToBody(fingerprintUrlQuery);
        }
    }
};

/**
 * Cria um fallback noscript para o fingerprint da cyber.
 * @param {string} fingerprintUrlQuery Query url com os parâmetros para carregar o fingerprint
 */
function appendCyberNoscriptToBody(fingerprintUrlQuery)
{
    let noscriptTag = document.createElement('noscript');
    let noscriptIframe = document.createElement('iframe');
    noscriptIframe.setAttribute('style', 'width: 100px; height: 100px; border: 0; position:absolute; top: -5000px;');
    noscriptIframe.setAttribute('src', `//h.online-metrix.net/fp/tags${fingerprintUrlQuery}`);

    noscriptTag.appendChild(noscriptIframe);
    document.body.appendChild(noscriptTag);
}